import { render, staticRenderFns } from "./TrainedPersonnel.vue?vue&type=template&id=45dc1d47&scoped=true"
import script from "./TrainedPersonnel.vue?vue&type=script&lang=js"
export * from "./TrainedPersonnel.vue?vue&type=script&lang=js"
import style0 from "./TrainedPersonnel.vue?vue&type=style&index=0&id=45dc1d47&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dc1d47",
  null
  
)

export default component.exports